import { render, staticRenderFns } from "./adesioniJSONReportFornitore.vue?vue&type=template&id=28dbb75c&"
import script from "./adesioniJSONReportFornitore.vue.ts?vue&type=script&lang=ts&"
export * from "./adesioniJSONReportFornitore.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports